import {Lang} from 'yougile-lang'
import {DataObjectPropertiesValue} from 'yougile-model'

export function getPlaceholder(stickerType: DataObjectPropertiesValue): string {
  if (stickerType === 'string') {
    return Lang.msg.myStickers.selectStateByDefault
  }

  if (stickerType === 'sprint') {
    return Lang.msg.myStickers.currentInterval
  }

  return ''
}
